import React, { useEffect, useState } from "react";
import useClickOutside from "../../utils/CustomHooks/useClickOutside";
import { Trans } from "react-i18next";
import { t } from "i18next";

const OptionsDropdown = ({
    optionsList,
    options,
    setOptions,
    applyOptions,
    title = "options",
    disabled = false,
    clearBtn = true,
}) => {
    const [optionsDropdown, setOptionsDropdown] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState({});
    const [selectedOptionsCount, setSelectedOptionsCount] = useState(0);

    useEffect(() => {
        let defaultSelected = {};
        let count = 0;
        for (const key in options) {
            if (options[key]) {
                defaultSelected[key] = true;
                count++;
            }
        }
        setSelectedOptions(defaultSelected);
        setSelectedOptionsCount(count);
    }, [options]);

    useEffect(() => {
        handleApplyOptions();
    }, [selectedOptions]);

    const toggleOptionsButton = () => {
        setOptionsDropdown(!optionsDropdown);
    };

    const closeOptionsButton = () => {
        setOptionsDropdown(false);
    };

    const incrementFilter = () => {
        setSelectedOptionsCount(selectedOptionsCount + 1);
    };

    const decrementFilter = () => {
        setSelectedOptionsCount(selectedOptionsCount - 1);
    };

    const handleCheckboxClicked = (optionName) => {
        let newselectedOptions = { ...selectedOptions };
        newselectedOptions[optionName] = !newselectedOptions[optionName];
        selectedOptions[optionName] ? decrementFilter() : incrementFilter();
        setSelectedOptions(newselectedOptions);
    };

    const handleClear = () => {
        setSelectedOptions({});
        setSelectedOptionsCount(0);

        //empty state
        setOptions({});
        closeOptionsButton();
        applyOptions && applyOptions({});
    };

    const handleApplyOptions = () => {
        closeOptionsButton();
        applyOptions && applyOptions({ ...selectedOptions });
    };

    const optionsRef = useClickOutside(closeOptionsButton);

    const renderOptions = () => {
        return (
            optionsList &&
            optionsList.map((option, index) => {
                return (
                    <div key={index}>
                        <div className="filter-items-options">
                            <div
                                className={`${
                                    !option.element &&
                                    "filter-items-options-header"
                                } border-bottom`}
                            >
                                {option.element ? (
                                    option.element(closeOptionsButton)
                                ) : (
                                    <div className="checkbox-wrapper-input filter-checker-btn">
                                        <input
                                            onChange={() => {
                                                handleCheckboxClicked(
                                                    option.name
                                                );
                                            }}
                                            type="checkbox"
                                            className="checkbox-element"
                                            id={`checkbox-option-${index}`}
                                            data-filter={`filter-content-${index}`}
                                            checked={
                                                selectedOptions[option.name] ||
                                                false
                                            }
                                        />
                                        <label
                                            htmlFor={`checkbox-option-${index}`}
                                        >
                                            {option.label}
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })
        );
    };

    return (
        <>
            <div className="filter-content-wrapper" ref={optionsRef}>
                <button
                    className={`default-orange-outline-btn flex items-center ${
                        disabled && "disabled"
                    }`}
                    data-element="filter-options-list"
                    onClick={toggleOptionsButton}
                    disabled={disabled}
                >
                    <div className="flex items-center">
                        <div className="flex items-center">
                            <i className="fas fa-cog"></i>
                            <span className="ml-2">{t(title)}</span>
                        </div>
                        <div
                            className={`number-checked-wrapper ${
                                selectedOptionsCount === 0 && "hidden"
                            }`}
                        >
                            {selectedOptionsCount}
                        </div>
                    </div>
                </button>
                <div
                    className={`filter-items shadow ${
                        optionsDropdown ? "show" : ""
                    }`}
                    id="filter-options-list"
                >
                    <div
                        className={`filter-items-header border-bottom flex items-center ${
                            clearBtn ? "justify-between" : "justify-center"
                        }`}
                    >
                        <span className="filter-title">
                            <Trans i18nKey="options">Options</Trans>
                        </span>
                        {clearBtn && (
                            <button
                                onClick={handleClear}
                                className="default-orange-btn clear-filter-btn"
                            >
                                <Trans i18nKey="clear">Clear</Trans>
                            </button>
                        )}
                        <button
                            onClick={handleApplyOptions}
                            className="default-orange-btn hidden"
                        >
                            <Trans i18nKey="done">Done</Trans>
                        </button>
                    </div>
                    {renderOptions()}
                </div>
            </div>
        </>
    );
};

export default OptionsDropdown;
